// Maps an automation rule from one platform's shape to another platform's
// create-rule payload — used by the "Duplicate to..." action on the
// WhatsApp/Instagram/Facebook automation pages. Pure client-side transform;
// every platform's create-rule endpoint already accepts a plain rule object,
// so the mapped result is fed straight into the target page's own existing
// New Rule form for the tenant to review before saving — nothing is created
// automatically.
//
// Deliberately NOT carried over (see plan for why):
//   - priority: WhatsApp sorts rules descending (higher wins), Instagram/
//     Facebook sort ascending (lower wins) — copying the raw number across
//     would silently invert its meaning. Always resets to 0.
//   - isActive: always resets to false — a copied rule needs a human's
//     review on the new platform before it can fire.
//   - scope/postIds (Instagram/Facebook only): a post ID from one platform
//     means nothing on another. Always resets to all_posts/[].

function isMetaKeywordPlatform(platform) {
  return platform === 'instagram' || platform === 'facebook';
}

export function mapRuleAcrossPlatforms(sourcePlatform, sourceRule, targetPlatform) {
  const name = sourceRule.name || '';
  const keywords = Array.isArray(sourceRule.keywords) ? [...sourceRule.keywords] : [];
  let matchingType = sourceRule.matchingType || 'contains';

  // Instagram/Facebook's 'any' (match everything) has no WhatsApp equivalent —
  // map it to 'contains' with no keywords, which simply never matches until
  // the tenant adds keywords, rather than silently becoming a new catch-all.
  if (targetPlatform === 'whatsapp' && matchingType === 'any') {
    matchingType = 'contains';
  }

  // The one field genuinely worth carrying: the reply text.
  let responseText = '';
  if (isMetaKeywordPlatform(sourcePlatform)) {
    responseText = sourceRule.responseTemplate || '';
  } else if (sourcePlatform === 'whatsapp' && sourceRule.actionType === 'send_text') {
    responseText = sourceRule.actionConfig?.text || '';
  }

  const base = {
    name,
    keywords,
    matchingType,
    priority: 0,
    isActive: false,
  };

  if (targetPlatform === 'whatsapp') {
    return {
      ...base,
      triggerType: 'keyword',
      actionType: 'send_text',
      actionConfig: { text: responseText },
    };
  }

  // instagram / facebook
  return {
    ...base,
    channel: 'dm',
    scope: 'all_posts',
    postIds: [],
    actionType: 'send_dm',
    responseTemplate: responseText,
    campaignTag: '',
  };
}
